import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
  TextField,
  InputAdornment,
  Skeleton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { reportSections } from '../../components/reports/data/reportsData';
import ReportCard from '../../components/reports/ReportCard';
import { useNavigate } from 'react-router-dom';
const ReportsPage = () => {
  const [loading, setLoading] = useState(true);
  const [sections, setSections] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    // Simulate API delay
    setTimeout(() => {
      setSections(reportSections); // Replace with real API response if needed
      setLoading(false);
    }, 1500);
  }, []);

  return (
    <>
      <Box sx={{ backgroundColor: '#f8f9fb', minHeight: '100vh', p: 3 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Typography variant="h5" fontWeight={600} sx={{ fontSize: '24px !important' }}>
            Reports
          </Typography>
          <Box display="flex" gap={2}>
            <TextField
              placeholder="Search Reports"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                sx: { borderRadius: '20px', background: '#fff' },
              }}
            />
            <Button variant="contained" sx={{ borderRadius: '30px', textTransform: 'capitalize', fontSize: '16px', padding: '3px 20px', background: '#0076FE' }} onClick={() => navigate('/scheduled-reports')}>
              Scheduled reports
            </Button>
          </Box>
        </Box>

        {sections.map((section) => (
          <Box key={section.title} mb={5}>
            {section.title !== 'Trending reports' && (
              <Typography fontSize={17} fontWeight={600} color='#1A1F36' mb={2}>
                {section.title}
              </Typography>
            )}

            <Grid
              container
              spacing={2}
              columns={60}
              className={
                section.title !== 'Trending reports'
                  ? 'card-body p-20 bg-base border rounded-3'
                  : ''
              }
              sx={
                section.title === 'Trending reports'
                  ? {
                    display: 'grid',
                    gridTemplateColumns: {
                      xl: 'repeat(auto-fill, minmax(300px, 1fr))', lg: 'repeat(auto-fill, minmax(280px, 1fr))',
                      md: 'repeat(auto-fill, minmax(260px, 1fr))',
                      sm: 'repeat(auto-fill, minmax(200px, 1fr))'
                    },
                    gap: '1rem',
                  }
                  : {
                    display: 'grid',
                    gridTemplateColumns: {
                      xl: 'repeat(auto-fill, minmax(250px, 1fr))',
                      lg: 'repeat(auto-fill, minmax(200px, 1fr))',
                      md: 'repeat(auto-fill, minmax(200px, 1fr))',
                      sm: 'repeat(auto-fill, minmax(200px, 1fr))',
                      xs: 'repeat(auto-fill, minmax(200px, 1fr))',
                    },
                    gap: '0rem',
                    background: '#fff',
                  }
              }
            >
              {loading ? (
                Array.from({ length: 5 }).map((_, idx) => (
                  <Grid item xs={60} sm={30} md={20} lg={12} xl={12} key={idx}>
                    <Skeleton
                      variant="rectangular"
                      height={120}
                      sx={{ borderRadius: 2 }}
                    />
                  </Grid>
                ))
              ) : section.items.length === 0 ? (
                <Grid item xs={60}>
                  <Typography variant="body1" textAlign="center" py={3}>
                    No data available
                  </Typography>
                </Grid>
              ) : (
                section.items.map((item, idx) => (
                  <Grid item xs={60} sm={30} md={20} lg={12} xl={12} key={idx}>
                    <ReportCard
                      {...item}
                      trending={section.title === 'Trending reports'}
                    />
                  </Grid>
                ))
              )}
            </Grid>
          </Box>
        ))}
      </Box>
    </>


  );
};

export default ReportsPage;
